var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretDown = function SvgCaretDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m7.406 11.784-5.16-4.526a.675.675 0 0 1 0-1.042.926.926 0 0 1 1.189 0L8 10.22l4.565-4.004a.926.926 0 0 1 1.189 0 .675.675 0 0 1 0 1.042l-5.16 4.526A.9.9 0 0 1 8 12a.9.9 0 0 1-.594-.216"
  })));
};
export default SvgCaretDown;